
/**
 * A helper function that helps validate the pre-reqs of a unit
 */
 class PreReqValidator {

   static prerequisitesExistTest(unit, allUnitCodes, requirements) {  // LOGIC STOLEN FROM ValidateCoursePlan.js:prerequisitesExistTest
      //no requirements, just return
      if (!requirements)
         return true;

      if (requirements.or) {
          if (requirements.or.some(r => this.prerequisitesExistTest(unit, allUnitCodes, r))) {
              return true;
          }
      }
      else if (requirements.and) {
          if (requirements.and.every(r => this.prerequisitesExistTest(unit, allUnitCodes, r))) {
              return true;
          }
      }
      else {
          if (allUnitCodes.some(a => a == requirements)) return true;
      }

      return false;
    }
}

module.exports = PreReqValidator
